'use client'

import { useEffect, useState, type ReactNode } from 'react'

import styles from '@/app/style-guide/hearing-aids-hub/brands.module.css'
import {
  featuredBrandTracking,
  shuffleFeaturedBrands,
  type FeaturedBrand,
} from '@/lib/hearing-aids-hub/featured-brands'

export interface FeaturedBrandItem {
  brand: FeaturedBrand
  card: ReactNode
}

export const FeaturedBrands = ({ items }: { items: FeaturedBrandItem[] }) => {
  const [ordered, setOrdered] = useState<FeaturedBrandItem[] | null>(null)
  useEffect(() => {
    setOrdered(shuffleFeaturedBrands(items))
  }, [items])

  return (
    <ul className={styles.featuredGrid}>
      {(ordered ?? items).map(({ brand, card }, index) => (
        <li
          key={`${ordered ? 'ready' : 'initial'}-${brand.slug}-${index}`}
          className={styles.featuredItem}
          {...(ordered ? featuredBrandTracking(brand, index) : {})}
        >
          {card}
        </li>
      ))}
    </ul>
  )
}
